export const TEST = "/contact";

export const APPLICATION_FORM = '/application-form'
export const APPLICATION_FORM_PDF = '/application-form-pdf'
export const PAYMENT = '/payment'

